/**
 * «ویزیت آنلاین سازمانی» on the real pages — only for the one rolled-out account (rollout.ts).
 * Every piece renders nothing for anyone else and on the server. Loaded lazily, for signed-in users only;
 * the price pieces that run in every search card live in livePrices.tsx.
 */
import { OrganizationLogo } from './components/organizationLogo';
import { CorporateHomeNote, CorporateWelcome } from './components/personal';
import { useSearchRouting } from '@/modules/search/hooks/useSearchRouting';
import { useRouter } from 'next/router';
import { useCorporateMember } from './rollout';

/** Header, after the Paziresh24 logo: the site's partner co-branding (dashed divider + partner logo). */
export const CorporateHeaderMark = ({ size = 'mobile' }: { size?: 'mobile' | 'desktop' }) => {
  const member = useCorporateMember();
  if (!member) return null;
  return (
    <>
      <hr className="h-8 rounded-full border border-dashed border-slate-300" />
      <OrganizationLogo organization={member.plan.organization} height={size === 'mobile' ? 26 : 32} />
    </>
  );
};

/** Home, under the search box. */
export const CorporateHomeEntry = () => {
  const member = useCorporateMember();
  if (!member) return null;
  return <CorporateHomeNote plan={member.plan} />;
};

/**
 * Top of the search results. «گفت‌وگو با پزشک» turns the same search (text, specialty, city) into its
 * online-visit doctors, like the site's own consult banner; already there, the card has no button.
 */
export const CorporateSearchWelcome = ({ className }: { className?: string }) => {
  const member = useCorporateMember();
  const { query } = useRouter();
  const { changeRoute } = useSearchRouting();
  if (!member) return null;
  const isConsult = query.turn_type === 'consult';
  return (
    <CorporateWelcome
      plan={member.plan}
      firstName={member.firstName}
      className={className}
      onChat={isConsult ? undefined : () => changeRoute({ query: { turn_type: 'consult' } })}
      showAction={!isConsult}
    />
  );
};
